import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { AI_INSIGHTS_KEY } from './constants';

type AIInsightsDataAvailable = {
    member_details: boolean;
    current_adherence: boolean;
    previous_adherence: boolean;
    config: boolean;
    care_profile: boolean;
    drug_interactions: boolean;
};

export type AIInsightsResponse = {
    digest: string;
    data_available: AIInsightsDataAvailable;
};

const useGetMemberAIInsights = (heroUserId: number | null) => {
    const req = useRequest();
    const digestCallId = useMemo(() => crypto.randomUUID(), []);

    const action = useCallback(() => {
        return req<AIInsightsResponse>({
            url: `${envVars.API_AI_HOSTNAME}care-manager-digest/${heroUserId}`,
            query: { call_id: digestCallId }
        });
    }, [req, heroUserId, digestCallId]);

    const query = useQuery({
        queryKey: [AI_INSIGHTS_KEY, heroUserId],
        queryFn: action,
        enabled: heroUserId !== null,
        staleTime: Infinity
    });

    return { ...query, digestCallId };
};

export default useGetMemberAIInsights;
